// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--f259p","table":"table--fkLke"};